import React, { useEffect, useState } from "react";
import CustomCard from "../../styleComp/CustomCard";
import {
  Typography,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
} from "@mui/material";
import Box from "@mui/material/Box";
import axios from "axios";
import "moment/locale/he";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { RolesContext } from "../../context/User";

const InfoCard = ({ colorCard, mobil }) => {
  const [openOrders, setOpenOrders] = useState([]);
  const [hover, setHover] = useState(false);
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const [empty, setEmpty] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      try {
        let postData = {};
        postData = {
          withCredentials: true,
          top: 3,
        };

        const response = await axios.post("orders/getOrders", postData);
        setEmpty(false);
        setOpenOrders(response.data.data);
      } catch (error) {
        if (error.response.status === 404) {
          setEmpty(true);
        }
      }
    }

    fetchData();
  }, []);

  const navigationPage = (selectedValue) => {
    navigate(`/${selectedValue}`);
  };

  return (
    <>
      <Box
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        sx={{ display: { xs: "none", md: "flex" } }}
      >
        <CustomCard
          widthCard={"100vw"}
          heightCard={"31.5vh"}
          backgroundColorStyle={
            colorCard ? colorCard : hover ? "rgb(245,245,245)" : "white"
          }
        >
          {stateroles.roles.includes("openorder") ||
          stateroles.roles.includes("admin") ? (
            <>
              {!hover ? (
                <Box>
                  <Typography variant="h5"> הזמנות </Typography>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>מספר הזמנה</TableCell>
                          <TableCell>תאריך</TableCell>
                          <TableCell>שם לקוח</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {openOrders.map((component, index) => (
                          <TableRow key={index}>
                            <TableCell> {component.ORDNAME}</TableCell>
                            <TableCell>
                              {moment(component.CURDATE).format("L")}
                            </TableCell>
                            <TableCell>{component.CUSTDES}</TableCell>
                          </TableRow>
                        ))}
                        {empty ? (
                          <Typography variant="subtitle2" sx={{ color: "red" }}>
                            אין הזמנות
                          </Typography>
                        ) : null}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              ) : (
                <>
                  <div style={{ position: "relative" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => navigationPage("openorder")}
                      style={{
                        position: "absolute",
                        top: 100,
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 1,
                      }}
                    >
                      הזמנות
                    </Button>
                    <Box style={{ filter: "blur(4px)", flex: 1 }}>
                      <Typography variant="h5"> הזמנות </Typography>
                      <TableContainer>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>מספר הזמנה</TableCell>
                              <TableCell>תאריך</TableCell>
                              <TableCell>שם לקוח</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {openOrders.map((component, index) => (
                              <TableRow key={index}>
                                <TableCell> {component.ORDNAME}</TableCell>
                                <TableCell>
                                  {moment(component.CURDATE).format("L")}
                                </TableCell>
                                <TableCell>{component.CUSTDES}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </div>
                </>
              )}
            </>
          ) : null}
        </CustomCard>
      </Box>
    </>
  );
};

export default InfoCard;